<template>
    <main class="poster">
        <div :infinite-scroll-disabled="true">
          <img :src="youpPath+item" v-for="(item,index) in imgUrls" :key="index"/>
        </div>
        <return-home></return-home>
        <button @click="entoSouhuo" v-if="!$route.query.isContact"></button>
    </main>
</template>

<script>
import { IMG_BASE_URL } from '@/config'
import returnHome from '@/components/smartComponent/returnHome'
export default {
  data () {
    return {
      youpPath: IMG_BASE_URL,
      imgUrls: [
        // '/upaiyun/Sys/20180710/5296742490283120155.png',
        // '/upaiyun/Sys/20180710/5329146126188130873.png',
        // '/upaiyun/Sys/20180710/5303798761384672312.png',
        // '/upaiyun/Sys/20180710/5118660583643119716.png',
        // '/upaiyun/Sys/20180710/4758377354622519975.png'
        '/upaiyun/Sys/20190114/5677513373569644766.jpg',
        '/upaiyun/Sys/20190114/5597733302951800982.jpg',
        '/upaiyun/Sys/20190114/4911734854909477038.jpg'
      ]
    }
  },
  components: {
    returnHome
  },
  mounted () {
    if (this.$route.query.isContact) {
      this.imgUrls = [
        // 如何联系客服
        // '/upaiyun/Sys/20191122/4870751631624253606.jpeg'
        '/upaiyun/Sys/20200429/4939862538903302217.jpg'
      ]
    }
  },
  methods: {
    entoSouhuo () {
      this.$router.push({
        name: 'souhuo'
      })
    }
  }
}
</script>

<style scoped="scoped">
  .poster{
    position: relative;
  }
  .poster,.poster img{
    width:100%;
    display: block;
  }
  .poster button{
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    z-index: 10;
    background: transparent;
  }
</style>
